import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-icon-grid-with-hero-text-conven-feet.js';
const html = `
<div data-use-custom-width="false" data-custom-width="1204" class="container" data-attribute="container-content"
    style="--custom-width: 1204px;">
    <div class="wrap-card">
        <div data-attribute="card-title" class="card-title">
            <h2 style="text-align: center;">Why Your Feet Are Screaming For Help?</h2>
            <p style="text-align: center;">75% of adults will experience debilitating foot pain at some point. It's not
                just "getting old"
            <p style="text-align: center;">It's a sign that your foundation is collapsing!!!</p>
            <p style="text-align: center;">you recognize any of these symptoms, your current footwear is likely causing
                permanent damage.</p>
        </div>
        <div data-attribute="list-item" data-col-perview="4" data-bg-color-item="#006196"
            data-border-color-item="#006196" class="list-item"
            style="--bg-color-item: #006196; --border-color-item: #006196; --col-perview: 4;">
            <div data-attribute="icon-twc" class="item-twc">
                <div class="wrap-img">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ed9f806dc21e61303991.png"
                        alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                    <h3 style="text-align:center;">PLANTAR FASCIITIS</h3>
                    <p style="text-align:center;">Sharp heel pain caused by micro-tears from poor arch support.</p>
                </div>
            </div>

            <div data-attribute="icon-twc" class="item-twc">
                <div class="wrap-img">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1eda23f07c5c8bdc58af0.png"
                        alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                    <h3 style="text-align:center;">
                        <meta charset="utf-8">PERIPHERAL NEUROPATHY
                    </h3>
                    <p style="text-align:center;">Burning &amp; numbness that pinched nerves and cut off circulation.
                    </p>
                </div>
            </div>

            <div data-attribute="icon-twc" class="item-twc">
                <div class="wrap-img">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1eda6c44d3001960e6c62.png"
                        alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                    <h3 style="text-align:center;">
                        <meta charset="utf-8">BUNION INFLAMMATION
                    </h3>
                    <p style="text-align:center;">Red, swollen big toe joints forced into unnatural positions</p>
                </div>
            </div>

            <div data-attribute="icon-twc" class="item-twc">
                <div class="wrap-img">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1edab8560c4515ae01d8e.png"
                        alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                    <h3 style="text-align:center;">
                        <meta charset="utf-8">ARTHRITIS &amp; SWOLLEN JOINTS
                    </h3>
                    <p style="text-align:center;">Fluid buildup and stiffness from walking on hard surfaces..</p>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export default containerFuild(html, css);
